import React from 'react'

import RecentInvoicesPanelProvider from '../../components/invoices/recentPanel/RecentInvoicesPanelProvider'
import RecentInvoicesPageRail from '../../components/invoices/recentPanel/RecentInvoicesPageRail'
import MasterPage from './index'

type ShellProps = {
  children: React.ReactNode
  activeInvoiceId?: string
}

export const InvoicePagesShell: React.FC<ShellProps> = ({ children, activeInvoiceId }) => (
  <RecentInvoicesPanelProvider activeInvoiceId={activeInvoiceId}>
    <MasterPage
      stickyHeader
      hideBackButton
      rightRail={<RecentInvoicesPageRail />}
      contentBodyClassName='container-with-bg pt-3'
    >
      {children}
    </MasterPage>
  </RecentInvoicesPanelProvider>
)
